// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";

// ** UseJWT import to get config
import useJwt from "@src/auth/jwt/useJwt";

const config = useJwt.jwtConfig;

const initialUser = () => {
  const item = window.localStorage.getItem("userData");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {};
};

export const authSlice = createSlice({
  name: "authentication",
  initialState: {
    userData: initialUser(),
  },
  reducers: {
    handleLogin: (state, action) => {
      state.userData = action.payload;
      state[config.storageTokenKeyName] =
        action.payload[config.storageTokenKeyName];
      state[config.storageRefreshTokenKeyName] =
        action.payload[config.storageRefreshTokenKeyName];
      localStorage.setItem("userData", JSON.stringify(action.payload));
      localStorage.setItem(
        config.storageTokenKeyName,
        action.payload.accessToken
      );
      localStorage.setItem(
        config.storageRefreshTokenKeyName,
        JSON.stringify(action.payload.refreshToken)
      );

      // localStorage.setItem('permissions', JSON.stringify(action.payload.permissions))
    },
    handleLogout: (state) => {
      useJwt
        .logout()
        .then((res) => {
          console.log(res.data.data)
          localStorage.clear();
          if (res.data.data.token) {
            // state.userData = action.payload;
            // state[config.storageTokenKeyName] =
            //   action.payload[config.storageTokenKeyName];
            // state[config.storageRefreshTokenKeyName] =
            //   action.payload[config.storageRefreshTokenKeyName];
            localStorage.setItem(
              "userData",
              JSON.stringify({ accessToken: res.data.data.token })
            );
            localStorage.setItem(
              'userRoles',
              JSON.stringify(res?.data?.data?.roles ?? [])
            );
            // localStorage.setItem(
            //   config.storageTokenKeyName,
            //   action.payload.accessToken
            // );
            // localStorage.setItem(
            //   config.storageRefreshTokenKeyName,
            //   JSON.stringify(action.payload.refreshToken)
            // );
            const current_user_id = res.data.data.current_user_id;
            const tokenData = {
              accessToken: res.data.data.token,
            };
            // localStorage.setItem("email", JSON.stringify(email));
            localStorage.setItem(
              "current_user_id",
              JSON.stringify(res.data.data.current_user_id)
            );

            localStorage.setItem(
              "permissions",
              JSON.stringify(res.data.data.permissions)
            );
            localStorage.setItem("user_id", res.data.data.user_id);
            localStorage.setItem(
              "user",
              JSON.stringify(res.data.data.user.full_name)
            );
            localStorage.setItem(
              "user_account",
              JSON.stringify(res.data.data.user.account_number)
            );
            localStorage.setItem(
              "providers",
              JSON.stringify(res.data.data.user.providers)
            );
            localStorage.setItem(
              "practice_name",
              JSON.stringify(res.data.data.user.practice_name)
            );
            localStorage.setItem(
              "sidebar_" + current_user_id,
              JSON.stringify(res.data.data.sidebar)
            );
            localStorage.setItem(
              "profile_image",
              JSON.stringify(res.data.data.user.image)
            );
            localStorage.setItem(
              "show_referral",
              JSON.stringify(res.data.data.show_referer_practice)
            );
            localStorage.setItem(
              "show_upload_disclaimer_button",
              JSON.stringify(res.data.data.user.show_upload_disclaimer_button)
            );
            localStorage.setItem(
              "enable_credit_card_info",
              JSON.stringify(res.data.data.user.enable_credit_card_info)
            );



            localStorage.setItem("accessToken", res.data.data.token);

            if (res.data.data.login_by) {
              localStorage.setItem("login_by", res.data.data.login_by);
            }

            if (res.data.data.rand_string) {
              localStorage.setItem("rand_string", res.data.data.rand_string);
            }

            localStorage.setItem("show_remove_parent_btn", res.data.data.user.show_remove_parent_btn);

            if(res.data.data.previous_user_role  == "Yes")
              {
                 window.location.href = "/pending/users";
                   return;
              }
              else{

                window.location.href = "/users";
                return;
              }
            // Store rememberMe in localStorage if needed

            // dispatch(handleLogin(tokenData));
            // navigate("/otp");
          }
          window.location.href = "/login";
        })
        //
        .catch((err) => { });
      // state.userData = {}
      // state[config.storageTokenKeyName] = null
      // state[config.storageRefreshTokenKeyName] = null
      // // ** Remove user, accessToken & refreshToken from localStorage
      // localStorage.removeItem('userData')
      // localStorage.removeItem(config.storageTokenKeyName)
      // localStorage.removeItem(config.storageRefreshTokenKeyName)
      // localStorage.removeItem('otpToken');
      // localStorage.removeItem('permissions')
      // localStorage.removeItem('profile_image')
    },
  },
});

export const { handleLogin, handleLogout } = authSlice.actions;

export default authSlice.reducer;
